import getOptions from './getOptions';

export default {
  getOptions: getOptions
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/index.js
// module id = 139
// module chunks = 0